import gql from 'graphql-tag'

export const GetTeamMyStoresQuery = gql`
  query MyTeamStoresList {
    myTeamstores {
      teamStores {
        id
        shortId: short_id
        name
        items {
          design {
            shortId: short_id
          }
          visible
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/AddToTeamStore/data.ts